import { Button } from "@mui/material"
import { useState } from "react";
import { config } from "../../authConfig";
import SNEvent from "./interfaces/SNEvent";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";

const SaveDateButton = ({ event }: { event: SNEvent }) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const execute = useFetchMsal();

  // MM/dd/yyyy
  const getDateString = (date: string) => {
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
  };

  const handleSaveDate = async () => {
    try {
      setIsSaving(true);
      const url = `${config.rootAPIUrl}${config.rootAPIList?.saveEventDate}`;
      await execute("POST", url, { eventId: event.id, eventDate: getDateString(event.date!) });
      setIsSaving(false);
    } catch (error) {
      setIsSaving(false);
      console.error(error);
      throw new Error("Event date update has failed!");
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleSaveDate}
      sx={{ marginLeft: 2 }}
      disabled={isSaving}
    >
      Save
    </Button>
  )
}

export default SaveDateButton;
